import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';

export const PrivateRoute = ({ component: Component, scopes = null, ...rest }) => {
  const { isAuthenticated, hasScope } = useAuth();
  
  return (
    <Route
      {...rest}
      render={props => (
        isAuthenticated() && (scopes ? hasScope(scopes) : true) ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      )
      }
    />
  )
};